module.exports = __webpack_public_path__ + "static/media/IconTemplates_-79.3d05dd0c.svg";